<template>
  <collapsible-widget title="ANALIZA KOSZTÓW ZA ZAJĘCIE PASA DROGOWEGO" :accordion="accordion" :default-expanded="true">
    <b-alert class="m-2" :show="!roadLaneAnalysisDrawingEnded" variant="primary">
      <strong>Informacja.</strong> Opcje wyboru części pasa drogowego będą dostępne po narysowaniu planowanej inwestycji.
    </b-alert>
    <div v-show="roadLaneAnalysisDrawingEnded" class="p-2">
      <b-row>
        <b-col>
          <b-alert :show="validationFailed" variant="danger">
            <strong>Uwaga.</strong> Formularz zawiera błędy.
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <table class="table table-stripped">
            <thead>
              <tr>
                <th>
                  Odcinek
                </th>
                <th>
                  Rodzaj
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(roadLaneSegment, index) in roadLaneSegments" :key="index">
                <td>
                  {{ roadLaneSegment.odcinek }}
                </td>
                <td>
                  <b-row v-if="validated && !roadLaneSegment.kategoria_drogi">
                    <b-col>
                      <small class="text-danger">Należy wybrać rodzaj odcinka.</small>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-select 
                        v-model="roadLaneSegment.kategoria_drogi" 
                        :options="options" 
                        :state="validated && !roadLaneSegment.kategoria_drogi ? false : null"/>
                    </b-col>
                  </b-row>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn class="btn-block" variant="primary" @click="generateReport" size="sm">Generuj raport</b-btn>
        </b-col>
        <b-col>
          <b-btn class="btn-block" variant="outline-secondary" @click="cancel" size="sm">Anuluj</b-btn>
        </b-col>
      </b-row>
    </div>
  </collapsible-widget>
</template>

<script>
import CollapsibleWidget from './CollapsibleWidget';
import { mapGetters } from 'vuex';
import { STOP_ROAD_LANE_ANALYSIS, ROAD_LANE_GENERATE_REPORT } from '../store/actions.type';

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      options: [ 
        { value: null, text: 'Wybierz' },
        { value: 'gminna', text: 'Gminna' },
        { value: 'krajowa', text: 'Krajowa' },
        { value: 'powiatowa', text: 'Powiatowa' },
        { value: 'wojewodzka', text: 'Wojewódzka' }
      ],
      validated: false,
      validationFailed: false
    }
  },
  computed: {
    ...mapGetters(["roadLaneAnalysisDrawingEnded", "roadLaneSegments"]),
  },
  methods: {
    cancel() {
      this.$store.dispatch(STOP_ROAD_LANE_ANALYSIS);
    },
    async generateReport() {
      if (this.validate()) {
        this.validationFailed = false;
        await this.$store.dispatch(ROAD_LANE_GENERATE_REPORT);
      } else {
        this.validationFailed = true;
      }
    },
    validate() {
      this.validated = true;
      return this.roadLaneSegments.every(rls => !!rls.kategoria_drogi);
    }
  }
}
</script>
